import { PlusInSquareIcon } from "assets/icons";
import InfoIcon from "assets/icons/InfoIcon";
import { If } from "components";
import { useBoolean, useSearchParameter } from "hooks";
import { t } from "i18next";
import { ProductsSelector, ProductsSelectorTable } from "modules/products";
import { ProductSetDetailsModal } from "modules/productSets";
import { Button, FormField } from "ui";

import { ProductSetSelectorModal } from "./atoms";
import { ProductSetSelectorTable } from "./atoms/ProductSetSelectorTable";
import { FormProductsFieldProps } from "./ProductsFieldForForms.types";

import styles from "./ProductsFieldForForms.module.scss";

export const ProductsFieldForForms = ({
  productsList,
  onChangeProductsList,
  productSet,
  onChangeProductSet,
  errorMessage,
  withProductSetDetailsModal = true
}: FormProductsFieldProps) => {
  const {
    value: isProductsSelectorOpen,
    setTrue: openProductsSelector,
    setFalse: closeProductsSelector
  } = useBoolean(false);

  const {
    value: isProductSetSelectorOpen,
    setTrue: openProductSetSelector,
    setFalse: closeProductSetSelector
  } = useBoolean(false);

  const [openedProductSetId, setOpenedProductSetId] =
    useSearchParameter("set_id");

  return (
    <FormField errorMessage={errorMessage}>
      <div className={styles.productsField}>
        <div className={styles.productsField_addButtons}>
          {!productSet && onChangeProductSet && (
            <Button
              icon={<PlusInSquareIcon />}
              variant={"default"}
              onClick={openProductSetSelector}
            >
              {t("Add product set")}
            </Button>
          )}

          {onChangeProductsList && (
            <Button
              icon={<PlusInSquareIcon />}
              variant={"default"}
              onClick={openProductsSelector}
            >
              {t("Add products")}
            </Button>
          )}
        </div>

        {onChangeProductsList && (
          <ProductsSelector
            value={productsList}
            onChange={onChangeProductsList}
            isOpen={isProductsSelectorOpen}
            onClose={closeProductsSelector}
          />
        )}

        {onChangeProductSet && (
          <ProductSetSelectorModal
            selectedProductSet={productSet}
            onChangeSelectedProductSet={onChangeProductSet}
            isOpen={isProductSetSelectorOpen}
            onClose={closeProductSetSelector}
          />
        )}

        <If condition={!!productSet}>
          <>
            <span className={styles.selectedProductSetInfo}>
              <InfoIcon width={16} height={16} />
              {t(
                "Note, that image, title and description for product list screen in RA will be taken from the selected product set"
              )}
            </span>

            <ProductSetSelectorTable
              productSets={productSet ? [productSet] : []}
              selectedProductSet={productSet}
              onChangeSelectedProductSet={onChangeProductSet}
            />
          </>
        </If>

        <If condition={productsList.length > 0}>
          <ProductsSelectorTable
            products={productsList}
            onlyProductInfoColumn
            value={productsList}
            onChange={onChangeProductsList}
          />
        </If>
      </div>

      <If condition={!!openedProductSetId && withProductSetDetailsModal}>
        <ProductSetDetailsModal
          isOpen={!!openedProductSetId}
          withControls={false}
          onClose={() => setOpenedProductSetId(null)}
          setId={openedProductSetId}
        />
      </If>
    </FormField>
  );
};

export default ProductsFieldForForms;
